module.exports = __webpack_public_path__ + "static/media/ic_notification_success.677a95b0.svg";